import React, { PropsWithChildren } from 'react';
import { LoadingIndicator } from '@ihsm/ui-shared';
import { NoData } from 'shared/components/NoData';
import { useAppSelector } from 'state/store';

interface FullViewLoadingProps {
  forceLoadingScreen?: boolean;
  forceNoDataScreen?: boolean;
  disableLoadingView?: boolean;
}

export const FullViewLoading: React.FC<FullViewLoadingProps> = ({
  children,
  forceLoadingScreen = false,
  forceNoDataScreen = false,
  disableLoadingView = false,
}: PropsWithChildren<FullViewLoadingProps>) => {
  const { showFullLoadingScreen, noData } = useAppSelector(
    (state) => state.uiState
  );

  if (
    !disableLoadingView &&
    (showFullLoadingScreen || (forceLoadingScreen && !forceNoDataScreen))
  ) {
    return <LoadingIndicator />;
  }

  if (noData || forceNoDataScreen) {
    return <NoData />;
  }

  if (!children || Object.keys(children).length === 0) {
    return <></>;
  }

  return <>{children}</>;
};
